import React from 'react';
import { Container, Image, Row, Col, Button } from 'react-bootstrap';
import AppStore from '../../../Landing2.0/assets/icons/appstore-azul.svg';
import GooglePlay from '../../../Landing2.0/assets/icons/google-play-naranja.svg';
import LeftHand from '../../../Landing2.0/assets/icons/left-hand.svg';
import translate from '../../../../translate';
import './changeCrypto.css'

const ChangeCrypto = ({...props}) => {
  const {lan} = props;
  const transl = translate[lan].LandingCard.section3;


  return(
    <div className='background-movements-coins'>
      <div style={{position: 'relative'}}>
        <Image src={LeftHand} className='floating-left-hand-change-crypto'/>
      </div>
      <Container className=''>
        <Row className='separate-title'>
          <Col xl={12} className='change-crypto-center-title'>
            <h1 className='change-crypto-title'>
              {transl.title}
            </h1>
          </Col>
        </Row>
        <Row style={{marginTop: '30px'}}>
          <Col xl={12} className='best-way-store-btn'>
            <a className="stores-btn" href="https://apps.apple.com/mx/app/wirebit-digital/id1563970813" target='_blank'>
              <Image src={AppStore}/>
            </a>
            <a className="stores-btn" href="https://play.google.com/store/apps/details?id=com.wirebitdigitalapp" target='_blank'>
              <Image src={GooglePlay}/>
            </a>
          </Col>
        </Row>
        <div>
          <Row className='margin-top-change-crypto'>
            <Col xl={6} lg={6} md={6} className='margin-bottom-change-crypto'>
              <Col xl={12}>
                <h1 className='change-crypto-movements-title'>{transl.subtitle}</h1>
              </Col>
              <Col xl={12}>
                <p className='change-crypto-subtitle'>{transl.text}</p>
              </Col>
              <Col xl={12} className='center-btn-change-crypto'>
                <Button onClick={()=>window.open(window.location.origin + '/register','_blank')} className='create-account-btn'>{transl.btn_signup}</Button>
              </Col>
            </Col>
            {/* STEP CREATE ACCOUNT */}
            <Col xl={6} lg={6} md={6}>
              <Col xl={10} className='border-color-change-crypto'>
                <h1 className='title-step-change-crypto'>{transl.step1}</h1>
                <p className='text-step-change-crypto'>{transl.step1_description}</p>
              </Col>
              <Col xl={10} className='border-color-change-crypto'>
                <h1 className='title-step-change-crypto'>{transl.step2}</h1>
                <p className='text-step-change-crypto'>{transl.step2_description}</p>
              </Col>
              <Col xl={10}>
                <h1 className='title-step-change-crypto'>{transl.step3}</h1>
                <p className='text-step-change-crypto'>{transl.step3_description}</p>
              </Col>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default ChangeCrypto;